import { createSelector } from 'reselect';
export const getServicesSavingState = (state) => state.servicesIsSaving;
export const isServicesSaving = createSelector(getServicesSavingState, (isLoading) => isLoading);
